import { type EnvironmentInjector } from '@angular/core';

import { type LazyComponentDetails } from '@core/shared/util';
import { type ComponentPluginComponent } from '@mp/shared/component-plugins/util';
import type { CurrentOrganizationInfoTabPlugin, CurrentOrganizationInfoTabPluginInput } from '@mpk/shared/util';

export function createClinicCatalogInfoTabPlugin(): CurrentOrganizationInfoTabPlugin {
  return {
    label: 'Klinikkatalog',

    async getComponentDetails(
      parentInjector: EnvironmentInjector,
    ): Promise<LazyComponentDetails<ComponentPluginComponent<CurrentOrganizationInfoTabPluginInput>>> {
      const { ClinicCatalogInfoComponent } = await import('../components');

      return {
        component: ClinicCatalogInfoComponent,
        environmentInjector: parentInjector,
      };
    },
  };
}
